import { edmCampaign } from '@bingads-webui/edm-campaign';


const readCampaign = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .get({
      select: ['Budget', 'CampaignConversionGoal/Goals'],
    })
    .toPromise();

export const loadCampaign = (cid, aid, campaignId) =>
  readCampaign(cid, aid, campaignId);
